import { render, staticRenderFns } from "./Deductions.vue?vue&type=template&id=53df8820&scoped=true&"
var script = {}
import style0 from "./Deductions.vue?vue&type=style&index=0&id=53df8820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53df8820",
  null
  
)

export default component.exports